export const LOADER_ORIGINS             =    'LOADER_ORIGINS';
export const GET_ORIGINS                =    'GET_ORIGINS';
export const ORIGINS_FAIL               =    'ORIGINS_FAIL';
export const SAVE_LOADER_ORIGINS        =    'SAVE_LOADER_ORIGINS';
export const FORM_ORIGINS_FAIL          =    'FORM_ORIGINS_FAIL';

